module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_software.e9e5aa3b.png";